import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Root redirect component
 * Redirects to /form if authenticated, otherwise to /login
 */
const RootRedirect: React.FC = () => {
  const { isAuthenticated } = useAuth();
  
  return <Navigate to={isAuthenticated ? '/form' : '/login'} replace />;
};

export default RootRedirect;











